import Vue from 'vue'

const TOKEN_KEY = '_big_data_calll_token'

const resizeBox = (el) => {
    const resizeChildren = () => {
        const children = el.children
        for (let i = 0; i < children.length; i++) {
            const t = children[i]
            if (t.nodeType === 1 && t.id) {
                try {
                    const instance = echarts.getInstanceByDom(t)
                    if (instance) {
                        instance.resize()
                    }
                } catch (e) {
                    // Error
                }
            }
        }
    }

    try {
        const instance = echarts.getInstanceByDom(el)
        if (instance) {
            instance.resize()
        } else {
            resizeChildren()
        }
    } catch (e) {
        // ERROR
        resizeChildren()
    }
}

const resize = {
    token: 0,
    resizeCallList: [],
    addCall(el) {
        this.resizeCallList.push(
            ((e) => {
                return () => {
                    resizeBox(e, true)
                }
            })(el)
        )
        return this.token++
    },
    removeCall(token) {
        this.resizeCallList.splice(token, 1)
    }
}

let timer = null
window.addEventListener(
    'resize',
    () => {
        if (timer) {
            clearTimeout(timer)
        }
        timer = setTimeout(() => {
            resize.resizeCallList.forEach((call) => call())
            timer = null
        }, 100)
    },
    false
)

/**
 * 自适应屏幕指令
 */
export default {
    init() {
        Vue.directive('autoSize', {
            bind: function(el) {
                el[TOKEN_KEY] = resize.addCall(el)
            },
            unbind: function(el) {
                resize.removeCall(el[TOKEN_KEY])
            }
        })
    }
}
